import { FC, useState } from 'react';
import ContingencyModal from 'app/viaje/viajeTraslado/coordinar/components/ContingencyModal';

interface Props {
  onSuccess?: () => void;
  label?: string;
}

const CreateContingencyButton: FC<Props> = ({
  onSuccess,
  label = '+ Contingencia'
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        title="Crear contingencia"
        style={{
          backgroundColor: '#9c27b0',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          padding: '6px 14px',
          fontSize: '13px',
          fontWeight: 600,
          cursor: 'pointer',
          transition: 'background-color 0.2s ease'
        }}
        onMouseEnter={(e) =>
          ((e.target as HTMLButtonElement).style.backgroundColor = '#7b1fa2')
        }
        onMouseLeave={(e) =>
          ((e.target as HTMLButtonElement).style.backgroundColor = '#9c27b0')
        }
      >
        {label}
      </button>
      <ContingencyModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onSuccess={onSuccess}
      />
    </>
  );
};

export default CreateContingencyButton;
